module.exports = __webpack_public_path__ + "static/media/projects.153dfe3e.png";